import React from 'react'
import { Buffer } from 'buffer'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from './core/store'

import App from './App'
import './style/less/index.less'

if (typeof window !== 'undefined') {
  window.Buffer = Buffer
}

const container = document.getElementById('root')!
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
)
